import { ApplicationState } from '@/store';
import { LocaleData } from '@/translations/LocaleData';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import AfSwitch from '../AfSwitch';
import InputCheckboxWithTooltip from '../InputCheckboxWithTooltip';
import ClassFormCertificateSection from './CertificateSettingsSection';
import './style.scss';

interface Props {
    enableCourseCertificate?: boolean;
    enableProgramCertificate?: boolean;
    handleOnChange: CallableFunction;
    mandatory: boolean;
}

const ClassFormGeneralSettingsSection: React.FC<Props> = ({
    enableCourseCertificate = undefined,
    enableProgramCertificate = undefined,
    handleOnChange,
    mandatory,
}: Props) => {
    const strings: LocaleData = useSelector((state: ApplicationState) => state.locale.data);

    return (
        <section className="class-form-general-settings-section">
            <div className="container-general-settings">
                <div className="general-settings">
                    <p>{strings.GENERAL_SETTINGS}</p>
                    <div className="container-inputs">
                        <AfSwitch checked disabled onChange={() => {}} />
                        <span className="m-left--xs">{strings.CLOSED_CLASS}</span>
                        <span className="m-left--lg">
                            <InputCheckboxWithTooltip
                                initialValue={mandatory}
                                label={strings.ESSENTIAL_SECTION.ESSENTIAL}
                                onChange={(val: boolean) => {
                                    handleOnChange('mandatory', val);
                                }}
                                toolTip={strings.TOOLTIP_ITS_MANDATORY_TRAINING}
                            />
                        </span>
                    </div>
                </div>

                <ClassFormCertificateSection
                    enableCourseCertificate={enableCourseCertificate}
                    enableProgramCertificate={enableProgramCertificate}
                    handleOnChange={({ hasProgramCertificate, hasCourseCertificate }) => {
                        handleOnChange('enableProgramCertificate', hasProgramCertificate);
                        handleOnChange('enableCourseCertificate', hasCourseCertificate);
                    }}
                />
            </div>
        </section>
    );
};

export default memo(ClassFormGeneralSettingsSection);
